import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import useApi from "../../../services/auth/useApi";
import { AxiosError } from "axios";

import { useRecoilState } from "recoil";
import { inProgressSpaceListState } from "../../../recoil/spaces/inProgressSpaceListState";
import { SpaceIdType, SpaceType } from "../../../types/space";
import { SpaceStatus } from "../../../types/space/enum";
import { spaceQueryKeys } from "../queries";
import { usePreference } from "../../../hooks/preference/usePreference";
export const markSpaceDoneApi = async (
  api: ReturnType<typeof useApi>,
  projectId: SpaceIdType
): Promise<void> => {
  await api.patch(`/spaces/${projectId}`, { itemStatus: SpaceStatus.Completed });
};

export const useMarkSpaceDoneMutation = (
  options?: UseMutationOptions<void, AxiosError, SpaceIdType>
) => {
  const api = useApi();
  const queryClient = useQueryClient();
  const [inProgressSpaces, setInProgressSpaceList] = useRecoilState(inProgressSpaceListState);
  const { preference, updatePreference } = usePreference();

  return useMutation<void, AxiosError, SpaceIdType>({
    mutationFn: (projectId: SpaceIdType) => markSpaceDoneApi(api, projectId),
    onMutate: async (projectId) => {
      await queryClient.cancelQueries({ queryKey: spaceQueryKeys.status(SpaceStatus.InProgress) });
      await queryClient.cancelQueries({ queryKey: spaceQueryKeys.status(SpaceStatus.Completed) });

      return { projectId, previousProjectList: inProgressSpaces };
    },
    onSuccess: (data, variables, context) => {
      const { projectId } = context as { projectId: SpaceIdType; previousProjectList: SpaceType[] };

      queryClient.invalidateQueries({ queryKey: spaceQueryKeys.status(SpaceStatus.InProgress) });
      queryClient.invalidateQueries({ queryKey: spaceQueryKeys.status(SpaceStatus.Completed) });

      // NOTE archive 시 spaceSidebar에서 사라짐
      setInProgressSpaceList((prev) => prev?.filter((space) => space.id !== projectId) ?? []);

      updatePreference({
        selectedSpaceIds: preference?.selectedSpaceIds?.filter((spaceId) => spaceId !== projectId),
      });
    },
    ...options,
  });
};
